import React, { useState, useEffect, useContext, useRef } from 'react';
import FreeTrialForm from './FreeTrialForm'
import { ProductsContext } from '../../contexts/Products'
import { CustomerContext } from '../../contexts/Customer'
import { FormProvider, Util } from '@thinkwell/react.common'

export default function FreeTrial(props) {
  const [products] = useContext(ProductsContext)
  const [customer] = useContext(CustomerContext)

  Util.hideLoader();

  const productSkus = products.map((product) => product.variants[0].sku.toLowerCase())
  const skus = (props.skus || []).filter((sku) => productSkus.indexOf(sku.toLowerCase()) != -1)

  const data = {
    skus: skus
  }

  return (<FormProvider data={data}>
    <FreeTrialForm maxCourses={props.maxCourses} />
  </FormProvider>)
}
